import * as v from 'valibot';
import { nulltoOptional } from '../utils/validation-utils';
import type { StructuredContentDocument } from './types';

export const structuredContentBaseSchema = v.object({
  type: v.string(),
  version: v.string(),
  props: v.any(),
});

export const structuredContentDocumentSchema = v.custom<StructuredContentDocument>(
  value => {
    const response = v.safeParse(structuredContentBaseSchema, value);
    if (response.success) return true;
    return false;
  },
  issue => `Invalid structured content document: ${issue.message}}`,
);

const singleSCSchema = v.union([nulltoOptional(v.string()), structuredContentDocumentSchema]);

export const structuredContentSchema = nulltoOptional(
  v.union([v.array(singleSCSchema), singleSCSchema]),
);
